import { templateIsDualSelfContained } from "@/lib/heroCtaCompatibleTemplates";

/**
 * Whether hideCta should block rendering dual home templates in Index.tsx.
 *
 * hideCta describes BaseTemplate hero geo flags. Dual self-contained templates
 * (CountryTemplateAdmin) carry their own funnel — phantom hideCta must not
 * drop USExclusiveLanding / DualCTAVideoLanding / VideoTemplate.
 *
 * Real suppressions (GLOBAL_HIDE_HERO_CTA, kill switch) still block.
 */
export function hideCtaBlocksDualHome(
  hideCta: boolean,
  templateName: string,
  options?: {
    globalHideHeroCta?: boolean;
    killSwitchActive?: boolean;
  },
): boolean {
  if (!hideCta) return false;
  if (options?.killSwitchActive || options?.globalHideHeroCta) return true;
  return !templateIsDualSelfContained(templateName);
}

/** Intl home templates routed via Index.tsx useDualCta branch. */
export const INTL_DUAL_HOME_TEMPLATES = new Set([
  "VideoTemplate",
  "BaseTemplateInternationalDual",
  "DualCTAVideoLanding",
  "USExclusiveLanding",
]);

export function isIntlDualHomeTemplate(templateName: string): boolean {
  return INTL_DUAL_HOME_TEMPLATES.has(templateName);
}